import {object, string} from "yup";

const MAX_DAYS = 1000;

export default object({
  days: string()
    .when('reserved', {
      is: (val) => !!val,
      then: () => string()
        .test('daysMin', 'Min is 1 day', (val) => {
          return val > 0;
        })
        .test('daysMax', `Max is ${MAX_DAYS} days`, (val) => {
          return val <= MAX_DAYS;
        })
        .test('isNaN', 'Not a number', (val) => !isNaN(val))
        .required()
    })
})
